import React, { Component } from "react";

type Props = {
  containerX: number;
  width: number;
  height: number;
};

type State = {
  duration: number;
  minuteTickLength: number;
  minuteTickWidth: number;
  minuteTickStroke: string;
  smallSecondTickLength: number;
  smallSecondTickWidth: number;
  smallSecondTickStroke: string;
  largeSecondTickLength: number;
  largeSecondTickWidth: number;
  largeSecondTickStroke: string;
};

const LARGE_SECOND_TICK_STROKE = "#bfbebf";
const SMALL_SECOND_TICK_STROKE = "#d9dad9";
const MINUTE_TICK_STROKE = "#afafaf";
const TICK_LABEL_COLOR = "#7A7A7A";

export default class TimeTicks extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      duration: 150,
      minuteTickLength: 6,
      minuteTickWidth: 1.5,
      minuteTickStroke: MINUTE_TICK_STROKE,
      smallSecondTickLength: 2,
      smallSecondTickWidth: 1,
      smallSecondTickStroke: SMALL_SECOND_TICK_STROKE,
      largeSecondTickLength: 3,
      largeSecondTickWidth: 1,
      largeSecondTickStroke: LARGE_SECOND_TICK_STROKE,
    };
  }

  getTimePosition(num, sep = 5) {
    const { duration } = this.state;
    const { containerX, width, height } = this.props;
    return [((num * sep) / duration) * width + containerX, height / 2];
  }

  getStartPoint() {
    const { containerX, height } = this.props;
    const startX = containerX;
    const startY = height / 2;
    return [startX, startY];
  }

  getEndPoint() {
    const { containerX, width, height } = this.props;
    const endX = containerX + width;
    const endY = height / 2;
    return [endX, endY];
  }

  render() {
    const {
      duration,
      smallSecondTickLength,
      smallSecondTickWidth,
      smallSecondTickStroke,
      largeSecondTickLength,
      largeSecondTickWidth,
      largeSecondTickStroke,
      minuteTickLength,
      minuteTickWidth,
      minuteTickStroke,
    } = this.state;
    const [startX, startY] = this.getStartPoint();
    const [endX, endY] = this.getEndPoint();
    const AnchorLine = (
      <line
        x1={startX}
        y1={startY}
        x2={endX}
        y2={endY}
        style={{ stroke: MINUTE_TICK_STROKE, strokeWidth: 1 }}
      />
    );
    const minutesTickArr = generateArr(Math.floor(duration / 60));
    const MinutesTicks = minutesTickArr.map((num) => {
      const [posX, posY] = this.getTimePosition(num, 60);
      return (
        <g key={`min-${num}`}>
          <line
            x1={posX}
            y1={posY}
            x2={posX}
            y2={posY - minuteTickLength}
            style={{ stroke: minuteTickStroke, strokeWidth: minuteTickWidth }}
          />
          <text
            x={posX}
            y={posY - minuteTickLength - 2}
            fill={TICK_LABEL_COLOR}
            style={{ textAnchor: "middle" }}
          >{`${num} min`}</text>
        </g>
      );
    });
    const largeSecondsTickArr = generateArr(Math.floor(duration / 10));
    const LargeSecondsTicks = largeSecondsTickArr.map((num) => {
      const [posX, posY] = this.getTimePosition(num, 10);
      return (
        <g key={`large-tick-${num}`}>
          <line
            x1={posX}
            y1={posY}
            x2={posX}
            y2={posY - largeSecondTickLength}
            style={{
              stroke: largeSecondTickStroke,
              strokeWidth: largeSecondTickWidth,
            }}
          />
          {num % 6 > 0 && (
            <text
              x={posX}
              y={posY - largeSecondTickLength - 2}
              fill={TICK_LABEL_COLOR}
              style={{ textAnchor: "middle" }}
            >{`${num}0s`}</text>
          )}
        </g>
      );
    });
    const smallSecondsTickArr = generateArr(Math.floor(duration / 5));
    const SmallSecondsTicks = smallSecondsTickArr.map((num) => {
      const [posX, posY] = this.getTimePosition(num, 5);
      return (
        <line
          key={`small-tick-${num}`}
          x1={posX}
          y1={posY}
          x2={posX}
          y2={posY - smallSecondTickLength}
          style={{
            stroke: smallSecondTickStroke,
            strokeWidth: smallSecondTickWidth,
          }}
        />
      );
    });
    return (
      <g className="time-ticks">
        {AnchorLine}
        {SmallSecondsTicks}
        {LargeSecondsTicks}
        {MinutesTicks}
      </g>
    );
  }
}

function generateArr(num) {
  const tempArr = Array.from(Array(num), (v, k) => k);
  tempArr.push(tempArr.length);
  return tempArr;
}
